<template>
    <v-container class="fill-height d-flex align-center justify-center">
        <v-card elevation="0" width="100%" max-width="400" class="pa-6">
            <h2 class="text-center font-weight-bold text-3xl mb-6">Brand Room</h2>
            <v-form @submit.prevent="login">
                <v-text-field
                    v-model="email"
                    label="Email"
                    variant="outlined"
                    density="comfortable"
                    :rules="[rules.email]"
                    required
                />

                <v-text-field
                    v-model="password"
                    label="Пароль"
                    variant="outlined"
                    density="comfortable"
                    type="password"
                    required
                />

                <v-btn
                    block
                    color="primary"
                    size="large"
                    type="submit"
                    :disabled="!email || !password"
                >
                    <strong>Увійти</strong>
                </v-btn>

                <v-alert v-if="serverError" density="compact" type="error" class="mt-4">
                    {{ serverError }}
                </v-alert>
            </v-form>
        </v-card>
    </v-container>
</template>

<script setup>
import {ref} from 'vue'
import {useRouter} from 'vue-router'
import {useAuthStore} from '../stores/authStore'
import {login as loginApi} from '../api'
import rules from "../utils/validationRules.js";

const email = ref('')
const password = ref('')
const serverError = ref(null)
const authStore = useAuthStore()
const router = useRouter()

async function login() {
    serverError.value = null

    try {
        const response = await loginApi(email.value, password.value)
        console.log(response);
        if (response.status) {
            authStore.login(response.data.accessToken, response.data.user);
            router.push({name: 'Dashboard'})
        } else {
            serverError.value = response.message || 'Помилка авторизації'
        }
    } catch (error) {
        serverError.value = error.message || 'Виникла помилка, спробуйте пізніше.'
    }
}
</script>
